module.exports = __webpack_public_path__ + "img/4club-06.8fdeefe1.svg";